<template>
  <div class="index">
    <div class="index_nav">
      <div class="index-nav-left">中国产学研合作促进会创新人才库</div>
      <div>
        <el-dropdown @command="handleCommand">
          <div class="el-dropdown-link">
            <img src="../assets/static/img/tx.png" />
            <div>{{ username || "用户姓名" }}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="edit">修改密码</el-dropdown-item> -->
            <el-dropdown-item command="exit">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <!-- <div class="nav">
        <div>用户：{{ username }}</div>
        <div class="heng"></div>
        <div @click="handleput1()">修改密码</div>
        <div class="heng"></div>
        <div @click="romve">注销</div>
      </div> -->
    </div>
    <div class="index_main">
      <div class="main_l" v-if="activeUrl !== '/integrity'">
        <el-menu
          :default-active="activeUrl"
          class="el-menu-vertical-demo"
          @select="handleSelect"
          @close="handleClose"
          router
        >
          <template v-if="is_admin == 1">
            <!-- <el-menu-item index="/dict">字典</el-menu-item> -->
            <el-menu-item index="/talentManage">人才管理</el-menu-item>
          </template>
          <template v-if="is_admin == 2">
            <el-menu-item index="/info">个人信息</el-menu-item>
            <el-menu-item index="/experience">主要经历</el-menu-item>
            <el-menu-item index="/research">科研能力和学术水平</el-menu-item>
            <el-menu-item index="/formSubmit">在线提交</el-menu-item>
          </template>
        </el-menu>
      </div>
      <div class="main_r" :class="activeUrl === '/integrity' ? 'max-main' : ''">
        <router-view />
      </div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%">
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
        :label-width="formLabelWidth"
      >
        <el-form-item label="用户名" prop="user_name">
          <el-input v-model="form.user_name"></el-input>
        </el-form-item>
        <el-form-item label="旧密码" :label-width="formLabelWidth">
          <el-input
            v-model="form.old_password"
            autocomplete="off"
            placeholder="请输入旧密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="password"
          label="新密码"
          :label-width="formLabelWidth"
        >
          <el-input
            oninput="value=value.replace(/[\W]/g,'')"
            maxlength="20"
            type="password"
            v-model="form.password"
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item
          prop="phones"
          label="新密码"
          :label-width="formLabelWidth"
        >
          <el-input
            oninput="value=value.replace(/[\W]/g,'')"
            maxlength="20"
            type="password"
            v-model="form.password1"
            placeholder="请再次输入密码"
            @blur="Verification"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="queding">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      class="aaa"
      title="补充资料"
      :visible.sync="centerDialogVisible"
      width="30%"
      :show-close="fa"
    >
      <el-form
        :model="ruleForm"
        :rules="ruless"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        @close="centerDialogVisible = true"
        :close-on-click-modal="false"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="工作单位" prop="work_unit">
          <el-input v-model="ruleForm.work_unit"></el-input>
        </el-form-item>
        <el-form-item label="职务职称" prop="job">
          <el-input v-model="ruleForm.job"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="id_card">
          <el-input v-model="ruleForm.id_card"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="ruleForm.password"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email"></el-input>
        </el-form-item>

        <el-form-item label="性别" prop="sex">
          <el-radio-group v-model="ruleForm.sex">
            <el-radio label="男"></el-radio>
            <el-radio label="女"></el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { log_out, getUserInfo, create_review, forget } from '../axios/api'
export default {
  data () {
    return {
      fa: true,
      ruless: {
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        work_unit: [
          { required: true, message: '请输入工作单位', trigger: 'blur' }
        ],
        job: [{ required: true, message: '请输入职务职称', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' }
        ],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择活动资源', trigger: 'change' }],
        id_card: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ]
      },
      ruleForm: {
        name: '',
        email: '',
        sex: '',
        id_card: '',
        work_unit: '',
        password: '',
        token: sessionStorage.getItem('Token2')
      },
      menu: [],
      num: '',
      formLabelWidth: '80px',
      dialogFormVisible: false,
      centerDialogVisible: false,
      username: '',
      form: {
        mima: '',
        password: '',
        old_password: '',
        name: '',
        id: sessionStorage.getItem('ids'),
        token: sessionStorage.getItem('Token2')
      },
      rules: {
        user_name: [
          { required: true, message: '请填写用户名', trigger: 'blur' }
        ]
      },
      activeUrl: '',
      is_admin: null
    }
  },
  created () {
    // this.menu = JSON.parse(sessionStorage.getItem("menu"));
    // if (sessionStorage.getItem("id")) {
    //   console.log(123);
    //   this.num = sessionStorage.getItem("id") + "";
    // } else {
    //   this.num = this.menu[0].data["0"].id + "";
    // }
    this.activeUrl = this.$route.path
    if (sessionStorage.getItem('Token3')) {
      getUserInfo({ token: sessionStorage.getItem('Token3') }).then((res) => {
        if (res.data.code === 200) {
          sessionStorage.setItem('uinfo', JSON.stringify(res.data.data))
          this.username = res.data.data.user_name
          this.is_admin = res.data.data.is_admin
        }
      })
    }
  },
  components: {},

  methods: {
    handleCommand (command) {
      console.log(command, 'command')
      if (command === 'edit') {
        this.handleput1()
      } else {
        this.romve()
      }
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.token = sessionStorage.getItem('Token2')
          create_review(this.ruleForm).then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: '补充成功',
                type: 'success'
              })
              this.centerDialogVisible = false
              sessionStorage.setItem('status', 1)
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onBeforeClose (done) {
      done(false)
    },
    push (e) {
      console.log(e)
      sessionStorage.setItem('id', e.id)
      this.$router.push({ path: e.menu_url })
    },
    Verification () {
      if (this.form.password1.length >= 6) {
        if (this.form.password1 != this.form.password) {
          this.$message({
            message: '两次密码不一致请重新输入',
            type: 'error'
          })
          this.form.password1 = ''
        }
      } else {
        this.form.password = ''
        this.form.password1 = ''
        this.$message({
          message: '密码最低为6位数',
          type: 'error'
        })
      }
    },
    romve () {
      // console.log(sessionStorage.getItem("ids"));
      const params = {
        token: sessionStorage.getItem('Token3')
      }
      log_out(params).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: '退出成功',
            type: 'success'
          })
          sessionStorage.removeItem('Token3')
          this.$router.push({ path: '/login' })
        }
      })
    },
    handleSelect (key, keyPath) {},
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleput1 (e) {
      this.dialogFormVisible = true
      this.form = {}
    },
    queding () {
      this.form.token = sessionStorage.getItem('Token2')
      this.form.id = sessionStorage.getItem('ids')
      const params = this.form
      console.log(params)
      forget(params).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: '修改成功',
            type: 'success'
          })
          this.dialogFormVisible = false
        }
      })
    }
  },
  watch: {
    '$route.path': function (newValue, oldValue) {
      this.activeUrl = newValue
    }
  }
}
</script>

<style scoped lang="less">
.index {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.index_nav {
  width: 100%;
  background: url("../assets/static/img/bg.jpg") no-repeat 100%;
  // background: rgb(31, 34, 80);
  background-size: 100% 100%;
  /* background-size: cover; */
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 50px;
  color: #fff;
  box-sizing: border-box;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}
.index-nav-left {
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 5px;
}
.el-dropdown-link {
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  img {
    width: 50px;
    height: 50px;
    margin-right: 10px;
  }
}
.index_main {
  flex: 1;
  width: 100%;
  overflow-y: auto;
  /* display: flex; */
}
.main_l {
  width: 250px;
  height: 100%;
  float: left;
}
.main_r {
  width: calc(100% - 250px);
  height: 100%;
  background: #eee;
  box-sizing: border-box;
  padding: 10px;
  float: left;
  &.max-main {
    width: 100%;
  }
}
.nav {
  width: 440px;
  position: absolute;
  right: 40px;
  bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  color: #fff;
  font-size: 20px;
}
.heng {
  height: 15px;
  width: 2px;
  background-color: #fff;
}
.aaa .el-dialog__headerbtn {
  display: none;
}
</style>
